import { z } from 'zod'
export const setPresentationAsNotInterestingSchema = z.object({
  presentationId: z.string().uuid(),
  reason: z.string().nonempty(),
})
export type SetPresentationAsNotInteresting = z.infer<
  typeof setPresentationAsNotInterestingSchema
>
